<template>
  <div class="home-container min-h-screen flex flex-col items-center justify-center fade-in">
    <div class="text-center bg-white bg-opacity-100 p-8 rounded-lg">
      <h1 class="text-4xl font-bold text-gray-800 mb-4">Jacob Elliot Stocker</h1>
      <p class="text-xl text-gray-600 mb-6">Full-Stack Web Developer</p>
      <div class="space-x-4">
        <router-link to="/projects" class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">Projects</router-link>
        <router-link to="/contact" class="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600">Contact</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomePage'
};
</script>

<style scoped>
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.fade-in {
  animation: fadeIn 1s ease-in;
}
</style>